import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import FileSaver from "file-saver";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "SectionProductImages" })
export default class SectionProductImages extends Vue {
    public localizer: any = Localizer;
    public isShowInfo: boolean = true;
    public isLoading: boolean = false;
    public isDownloading: boolean = false;
    public formData: any = { bremboCodes: null, isProduct: true, isDrawing: true };
    public images: any[] = [];
    public validationErrors: any[] = [];
    public isAllItemsSelected: boolean = false;
    public selectedFiles: any[] = [];
    public bundleImages: any[] = [];

    public isGenerating: boolean = false;
    public bundleIndex: number = 0;
    public zip: any = new JSZip();

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const result = (await Axios.post(this.routes.MyBremboPartsFileSharingProductImage_GetBundleImages)).data;
        this.bundleImages = result;
    }

    public setAnalytics(fileName: string) {
        GTagHelper.sendEvent("file_download", "filesharing_images", fileName);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.selectedFiles = [];

        try {
            const result = (await Axios.post(this.routes.MyBremboPartsFileSharingProductImage_GetProductImages, this.formData)).data;
            this.images = result.images;

            this.isShowInfo = false;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public selectAllItems() {
        this.selectedFiles = [];

        if (!this.isAllItemsSelected) {
            for (let item of this.images) {
                this.selectedFiles.push(item);
            }

            this.isAllItemsSelected = true;
        }
    }

    public async downloadZip() {
        this.isDownloading = true;

        if (this.selectedFiles.length !== 0) {
            const vm = this;
            var promises = [];
            var files = [];
            this.bundleIndex = 0;
            this.isGenerating = true;

            for (var i = 0; i < this.selectedFiles.length; i++) {
                files.push({
                    name: this.selectedFiles[i].name,
                    idMaser: this.selectedFiles[i].idMaster
                });

                promises.push(new Promise((resolve, reject) => {
                    var file = this.selectedFiles[vm.bundleIndex];
                    vm.bundleIndex++;

                    JSZipUtils.getBinaryContent(file.bundleUrl, function (err, data) {
                        vm.zip.file(file.fileDownloadName, data);
                        resolve(0);
                    });
                }));
            }

            await Promise.all(promises);
            this.generateZip();
        }

        this.isDownloading = false;
    }

    public generateZip() {
        const vm = this;

        this.zip.generateAsync({ type: "blob" }).then(function (content) {
            FileSaver.saveAs(content, "BremboProductImages.zip");
            GTagHelper.sendEvent("file_download", "filesharing_images", "bundle");

            vm.isGenerating = false;
        });
    }

    public selectItem() {
        this.isAllItemsSelected = false;
    }

    public downloadImage() {
        GTagHelper.sendEvent("click", "filesharing_images", "image");
    }
}